module.exports = __webpack_public_path__ + "static/media/recommend-selected.27d48e38.svg";